import moment from "moment";
import { icons } from "../../../assets/icons";
import { displayDateFormat } from "../../../utils/helpers";

export const l1PendingColumns = ({ extraColumns = [], inBetweenColumns = [], downloadVoucher }) => [
  ...extraColumns,
  {
    Header: "Submit On",
    accessor: "submittedOn",
    Cell: (rowData) => {
      if (!rowData?.submittedOn) {
        return "-";
      }
      return (
        <div>
          {moment(
            rowData?.submittedOn
          ).format(displayDateFormat)}
          {/* {rowData?.submittedOn || ""} */}
        </div>
      );
    },
  },
  { 
    Header: "Request Amount (₹)", 
    accessor: "amount",
    Cell: (rowData) => {
      const value = rowData?.amount;
      let amount;
      if(typeof value == "string"){
        amount = Number(value).toFixed(2);
      } else {
        amount = value
      }
      return amount || "-";
    },
  },
  ...inBetweenColumns,
  {
    Header: "Pending",
    accessor: "pendingAmount",
    Cell: (rowData) => {
      const value = rowData?.pendingAmount;
      if (!value) {
        return "-";
      }
      return <div className={"text-[var(--pendingYellow)]"}>{value}</div>;
    },
  },
  // {
  //   Header: "Action",
  //   accessor: "",
  //   Cell: (rowData) => { 
  //     return (
  //       <div className="flex items-center gap-x-5">
  //         <div
  //           className={`cursor-pointer text-[#346BFF] underline text-[1.4rem]}`}
  //           onClick={() => {
  //             // return onClickViewFile(rowData?.id, rowData)
  //             downloadVoucher(rowData, "Pending")
  //           }}
  //         >
  //           Download
  //         </div>
  //       </div>
  //     );
  //   },
  // },
];
